module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<label>")
    ; __append(escapeFn( locals.label || 'Date Range' ))
    ; __append("</label> <form class=\"daterange-picker\"> <div> <input type=\"text\" class=\"form-control\"> <span class=\"down-arrow\"></span> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/datepicker_range.ejs
// module id = 888
// module chunks = 1